import { connect } from 'react-redux';
import { fetchFaqs } from 'app/actions/contentActions';
import NestedContent from 'app/components/static/NestedContent';

function mapStateToProps(state, { match }) {
  return {
    data: state.faqs.data,
    link: match.params.section ? `faqs/${match.params.section}` : undefined,
    isLoading: state.faqs.isLoading,
    title: match.params.section === 'cruncher' ? 'Fantasy Insider FAQs' : 'FAQs & Rules'
  };
}

const actions = {
  onMount: fetchFaqs
};

export default connect(mapStateToProps, actions)(NestedContent);
